<template>
  <div
    class="continue-stop"
    v-loading="loading"
    element-loading-text="正在查询房主信息，请稍后~"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-spinner="el-icon-loading"
  >
    <div class="continue-stop-back"></div>
    <div class="continue-stop-one" v-if="area">
      <div class="continue-stop-top">
        <div>
          <div style="padding: 0.2rem 0rem 0.05rem 0.2rem">
            <div>房屋卡号：{{ cardCode }}</div>
          </div>
          <div style="padding: 0.05rem 0rem 0.05rem 0.2rem">
            <div>房屋地址：{{ address }}</div>
          </div>
          <div style="padding: 0.05rem 0rem 0.2rem 0.2rem">
            <div>供热面积：{{ area }} ㎡</div>
          </div>
        </div>
      </div>
    </div>
    <div class="continue-stop-many" v-else>
      <div class="continue-stop-top">
        <div>
          <div style="padding: 0.2rem 0rem 0.05rem 0.2rem">
            <div>房屋卡号：{{ cardCode }}</div>
          </div>
          <div style="padding: 0.05rem 0rem 0.2rem 0.2rem">
            <div>房屋地址：{{ address }}</div>
          </div>
        </div>
      </div>
      <div class="eleclt-area">选择面积</div>
      <div class="continue-stop-content">
        <div
          class="continue-stop-item"
          v-for="(item, index) in hourseInfo"
          :key="index"
          @click="handleCheckClick(index)"
        >
          <div style="padding: 0.2rem 0rem 0.2rem 0.2rem">
            <div>
              <span style="color: #454545; font-size: 0.16rem">供热面积：</span>{{ item.area }} ㎡
            </div>
          </div>
          <div class="continue-stop-check">
            <span v-if="item.check">
              <img
                src="../../assets/image/selected-icon.png"
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
                alt
              />
            </span>
            <span v-else>
              <img
                src="../../assets/image/outcheck-icon.png"
                alt
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="continue-stop-buttom">
      <div :class="checkedFlag ? 'continue-stop-btn-check' : 'continue-stop-btn'">
        <el-button type="primary" @click="handleConfirmClick">确定</el-button>
      </div>
      <div class="continue-stop-btn">
        <el-button
          type="primary"
          style="
            background: rgba(0, 123, 131, 0.1);
            border: 1px solid rgba(0, 123, 131, 1);
            color: #007b83;
            opacity: 1;
          "
          @click="handleCancelClick"
          >取消</el-button
        >
      </div>
    </div>
    <div class="mark-hint" v-if="hintFlag">
      <div>
        <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
          <i class="iconfont iconguanbi" @click="hintFlag = false"></i>
        </div>
        <div style="color: #007b83; margin-top: 0.14rem">
          <div>
            <div style="padding: 0rem 0.3rem; font-size: 0.16rem">请选择需要续停的房屋面积！</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cardCode: '',
      phone: this.$route.query.phone,
      id_card: this.$route.query.id_card,
      hourseInfo: [],
      loading: false,
      owner_name: '',
      checkedFlag: true,
      address: '',
      areaId: [],
      allArea: [],
      checkedLength: 0,
      area: '',
      hintFlag: false,
    };
  },
  mounted() {
    document.title = '在线续停';
    this.getBindingInfo();
    this.getRoomOwnerInfo();
  },
  methods: {
    async getBindingInfo() {
      const res = await this.$http.get(`${this.$url.globalurl}/wxUser/0`);
      if (res.code == 200) {
        this.cardCode = res.result[0].heating_card_num;
        this.owner_name = res.result[0].owner_name;
      }
    },
    async getRoomOwnerInfo() {
      this.loading = true;
      const res = await this.$http.post(`${this.$url.globalurl}/wxContinueStop`, {
        phone: this.phone,
        id_card: this.id_card,
      });
      if (res.code == 200) {
        this.hourseInfo = res.result;
        this.hourseInfo.forEach((item) => {
          item.check = true;
        });
        this.address = this.hourseInfo[0].address;
        this.checkedLength = this.hourseInfo.length;
        this.loading = false;
        if (this.hourseInfo.length == 1) {
          this.area = this.hourseInfo[0].area;
          this.checkedFlag = true;
        }
      }
    },
    handleConfirmClick() {
      if (this.checkedFlag) {
        this.hourseInfo.forEach((item) => {
          if (item.check) {
            this.areaId.push(item.areaId);
            this.allArea.push(item.area + '㎡');
          }
        });
        this.$router.replace({
          name: 'agreement',
          query: {
            cardCode: this.cardCode,
            owner_name: this.owner_name,
            address: this.address,
            areaId: JSON.stringify(this.areaId),
            allArea: this.allArea.join('、'),
          },
        });
      } else {
        this.hintFlag = true;
      }
    },
    handleCancelClick() {
      this.$router.replace({
        name: 'index',
      });
    },
    handleCheckClick(index) {
      if (this.hourseInfo[index].check == true) {
        this.$set(this.hourseInfo[index], 'check', false);
      } else {
        this.$set(this.hourseInfo[index], 'check', true);
      }
      this.$forceUpdate();
      this.checkedLength = this.hourseInfo.reduce((prevalue, n) => {
        return prevalue + (n.check ? 1 : 0);
      }, 0);
      if (this.checkedLength != 0) {
        this.checkedFlag = true;
      } else {
        this.checkedFlag = false;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
@import url(continueStop.scss);
</style>
